<template>
  <v-hover v-slot="{hover}">
      <div class="pt-4" v-if="section.isHtml" >
        <h1>i am avalon</h1>
        <v-row  no-gutters  style="flex-wrap: nowrap; height: 100% !important" class="fill-height"  >

          <!-- Drag Icon-->
          <v-col style=" height: 100% !important;" class="flex-grow-0 flex-shrink-0 sideTransition fill-height">
            <v-sheet color="transparent" width="32" class="editor-section-drag">
              <v-icon v-if="hover"  style="cursor: grab"  :color="wsACCENT">
                mdi-drag-vertical
              </v-icon>
            </v-sheet>
          </v-col>
          <!-- Section Content -->
          <v-col style="min-width: 100px; max-width: 100%;" class="flex-grow-1 flex-shrink-0">

            <quill-editor
                @input="$emit('allow-edit-text' , true)"
                v-model="section.text"
                style="width: 100%; padding: 0 !important; margin: 0 !important;"
                class="section_paragraph"
                :options="editorOptions"
                :style="editorStyle"
                ref="quillRef"
            />

          </v-col>
          <!-- Section Edit Buttons -->
          <v-col style=" height: 100% !important;" class="flex-grow-0 flex-shrink-0 sideTransition fill-height">
            <v-sheet width="32" color="transparent" class="pl-1 fill-height " >
              <ft-select
                  @input="$emit('edit',$event)"
                  :items="editActionsSelect">
                <ws-icon-button v-if="hover" small   />
              </ft-select>
            </v-sheet>
          </v-col>

        </v-row>

      </div>
  </v-hover>

</template>

<script>
import 'quill/dist/quill.core.css'
import {quillEditor} from 'vue-quill-editor'

export default {
  name: "editorSectionHtml",
  components : {
    quillEditor
  },
  props : {
    value : {
      type : Object
    },
    section : {
      type : Object,
      default() { return {} }
    },
    lang : {
      type : String,
      default : 'ua',
    },
    placeholder : {
      type : String
    }
  },
  data() {
    return {
      editorOptions: {
        scrollingContainer: null,
        modules : {
          toolbar : true
        },
        theme: null,
      },
      editorStyle :
          '  font-family: \'Montserrat\', Helvetica, Arial, sans-serif;\n' +
          '  font-size: 24px;\n' +
          '  font-weight: 900 !important; \n' +
          '  line-height: 26px;\n' +
          '  margin : 0;\n' +
          '  outline : none; ',
    }
  },
  computed : {


    editActionsSelect() {
      return [
        { text : this.$t('Duplicate') , value: 'duplicate' , icon : 'mdi-content-copy' },
        { text : this.$t('Delete') , value: 'delete' , icon : 'mdi-delete-outline' },
      ];
    },
  },
  methods : {
    editorSetup(editor) {
      editor.on('init', () => {
        this.editorReady = true
      });
      editor.on('blur', () => {
        this.$emit('input', this.section)
      });
    }
  }
}
</script>

<style scoped>
</style>